<div class="fixActionRow">
    <h1 mat-dialog-title>{{status}}</h1>
    <div mat-dialog-content class="status">
        <status-line-component 
            *ngFor="let status of mlGen.statusResult" 
            [statusText]="status.text" 
            [done]="status.done"
            [error]="status.error">
        </status-line-component>
    </div>
    <div class="spacer"></div>
    <div mat-dialog-actions *ngIf="result !== undefined" align="end">
        <button mat-button (click)="onNoClick()">Cancel</button>
        <button mat-button *ngIf="result.status.error" (click)="onRetry()" cdkFocusInitial>Retry</button>
        <button 
            mat-button 
            *ngIf="(
                    !result.status.error && 
                    !result.status.cancel && 
                    !result.status.retry && 
                    result.status.okayToInsert && 
                    result.status.done
                ) || 
                (
                    result.status.okayToInsert && 
                    (
                        result.status.done || 
                        result.status.error
                    )
                )" 
            [mat-dialog-close]="result" 
            cdkFocusInitial>
            Insert into article
        </button>
    </div>
</div>